import React from "react";
import "./Trivia.css";
import Cuadro from "../../Layout/Cuadro";
import uno from "../../assets/images/uno.png";
import { Typography, Grid } from "@mui/material/";
import { Button } from "@mui/material/";
import { styled } from "@mui/material/styles";
import { useHistory } from "react-router-dom";

const SendButtonSmall = styled(Button)(({ theme }) => ({
  color: theme.palette.getContrastText("#000"),
  backgroundColor: "#1a5080",
  "&:hover": {
    backgroundColor: "#85a537",
  },
  width: "100px",
  height: "40px",
  fontWeight: "bold",
  fontSize: "14px",
  borderRadius: "20px",
  lineHeight: 1.2,
  boxShadow:
    "0 13px 27px -5px rgba(50, 50, 93, 0.25),    0 8px 16px -8px rgba(0, 0, 0, 0.3)",
}));

function Trivia() {
  let history = useHistory();

  return (
    <Cuadro bgCuadro="#fff">
      <Grid container spacing={2}>
        <Grid item xs={12} md={8}>
          <Typography
            variant="h6"
            gutterBottom
            component="div"
            className="tittle"
            align="justify"
          >
            Trivia de la buena energía.
          </Typography>
          <Typography
            variant="body2"
            gutterBottom
            component="div"
            className="subTittle"
            align="justify"
          >
            Para participar en esta actividad deberás responder las preguntas de
            manera correcta.
            <br />
            <br />
            Solo debes seleccionar la respuesta que creas correcta, esta es una
            trivia con selección multiple.
          </Typography>
        </Grid>
        <Grid item xs={12} md={4} sx={{ display: { xs: "none", md: "block" } }}>
          <div className="divNino">
            <img src={uno} alt="Niño" className="ninotrivia" />
          </div>
        </Grid>
        <Grid item xs={12} style={{ textAlign: "center" }}>
          <SendButtonSmall
            variant="contained"
            onClick={() => history.push("/TGame")}
          >
            JUGAR
          </SendButtonSmall>
        </Grid>
      </Grid>
    </Cuadro>
  );
}

export default Trivia;
